import { iconBaseProps, type IconProps } from "@/components/ui/icons/icon-base"

export const ShieldCheckIcon = ({ size = 22, ...props }: IconProps) => (
  <svg {...iconBaseProps(size, props)} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 3l8 3v6c0 4.5-3.5 8.5-8 9-4.5-0.5-8-4.5-8-9V6l8-3z" />
    <path d="M8.5 12l2.5 2.5L16 9.5" />
  </svg>
)
